var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./notification-list.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47b7fd12\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notification-list.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/notification/notification-list/notification-list.vue.html
// module id = B6/d
// module chunks = 2